import React from "react";
import { Navigate } from "react-router-dom";
import { ROUTES } from "./constants";
import { store } from "../store";

interface RoleRouteProps {
  roles: string[];
  element: React.ReactElement;
}

const RoleRoute: React.FC<RoleRouteProps> = ({ roles, element }) => {
  const { user } = store.getState().auth;
  const userRoles = user?.roles
    ? Array.isArray(user.roles)
      ? user.roles
      : [user.roles]
    : [];
  const hasAccess = roles.some((role) =>
    userRoles.some((userRole) =>
      typeof userRole === "string" ? userRole === role : userRole.name === role,
    ),
  );

  if (!hasAccess) {
    return <Navigate to={ROUTES.DASHBOARD.HOME} replace />;
  }

  return element;
};

export default RoleRoute;
